<script setup lang="ts">
import { ref } from 'vue';
import LogoOM from '@/assets/images/logo-om.svg?component';
import AppMenu from '@/components/app-layout/AppMenu.vue';
import AppMenuButton from '@/components/app-layout/AppMenuButton.vue';

const menuActive = ref(false);
</script>

<template>
  <header class="header">
    <div class="header-left">
      <NuxtLink
        href="/"
        class="logo"
      >
        <LogoOM class="logo-image" />
      </NuxtLink>
      <EnvStatus />
    </div>

    <AppMenuButton
      v-model:active="menuActive"
      class="menu-button"
    />
    <AppMenu
      class="menu"
      :class="{ 'is-active': menuActive }"
      :vertical="menuActive"
    />
  </header>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.header {
  --header-height: 7rem;

  height: var(--header-height);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2.4rem;

  @include screen.respond(tablet) {
    --header-height: 7.4rem;
  }
}
.header-left {
  display: flex;
  align-items: center;
  gap: var(--spacing-ms);
}
.logo,
.logo-image {
  height: 2rem;
}

.menu {
  &.is-active {
    position: fixed;
    width: 100%;
    top: var(--header-height);
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 101;
    background-color: #fff;
    padding: 2.4rem;
  }

  &:not(.is-active) {
    @include screen.respond(tablet) {
      display: none;
    }
  }
}
.menu-button {
  display: none;

  @include screen.respond(tablet) {
    display: block;
  }
}
</style>
